import { TextField } from "@mui/material";
import React, { useState } from "react";

const Test = () => {
  const [idInput, setIdInput] = useState("6501");

  return (
    <div>
      TEST DER
      <TextField
        value={idInput}
        onChange={(ev) => setIdInput(ev.target.value)}
      />
    </div>
  );
};

export default Test;
